import { render, staticRenderFns } from "./lpzylist.vue?vue&type=template&id=6617ae5a&"
import script from "./lpzylist.vue?vue&type=script&lang=js&"
export * from "./lpzylist.vue?vue&type=script&lang=js&"
import style0 from "./lpzylist.vue?vue&type=style&index=0&id=6617ae5a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports